/* globals angular */
"use strict";

// Página de download do relatório SLA acessada pelo link do e-mail.
// State standalone (sem o parent "historico"): é uma página de passagem que
// pede a URL pré-assinada ao cliente-services e redireciona para o download.
angular.module("mandaeApp").config(function($stateProvider) {
  $stateProvider.state("relatorio-sla-download", {
    url: "/relatorios/sla/:ano/:mes/:dia",
    component: "appRelatorioSlaDownload",
    data: {
      pageTitle: "Mandaê - Relatório SLA"
    }
  });
});
